/* eslint-disable jira/filename-case */
import {
	UFOExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
} from '@atlassian/ufo/ufo-experimental';
import { createJpdExperience } from './createJpdExperience.tsx';
import type {
	ExperienceErrorReason,
	ExperienceMetadataExtra,
	JPDExperience,
} from './ExperienceMetadataExtra.types.tsx';

export const openDialog: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.view-permissions.open-dialog', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const loadViewAccess: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.view-permissions.load-view-access', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const updateViewAccess: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.view-permissions.update-view-access', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const updatePrincipals: JPDExperience<ExperienceErrorReason, ExperienceMetadataExtra> =
	createJpdExperience(
		new UFOExperience('jpd.view-permissions.update-principals', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
		}),
	);

export const loadCurrentUserViewPermissions: JPDExperience<
	ExperienceErrorReason,
	ExperienceMetadataExtra
> = createJpdExperience(
	new UFOExperience('jpd.view-permissions.load-current-user-view-permissions', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);
